export default __webpack_public_path__ + "static/media/dashboard-hero.b915d5fc.png";